const callForExhibitorsConfig = {
  starts: '2026-07-20T09:00:00-06:00',
  // NOTE: Exhibitors can start editing booths once the expoHall is closed.
  dashboard: {
    opens: '2026-08-17T09:00:00-06:00',
    closes: '2027-01-27T23:59:59-07:00',
  },
  submissionEnds: '2026-12-08T23:59:59-07:00',
  acceptanceEnds: '2027-02-18T23:59:59-07:00',
  promotionEditEnds: '2027-02-09T07:00:00-07:00',
  ends: '2027-02-19T23:59:59-07:00',
}

export default callForExhibitorsConfig
